import React, {memo, Suspense} from "react"
import {MANIFEST} from "@manifest/plp"
import {useTemplatedComponent} from "@next/templating"
import connect from "./connect"
import {FacetState} from "../../../../../models/FacetsState"

export interface SingleFacetLabelProps {
    templating: {mainTemplate: string; fallbackTemplate: string}
    facet: FacetState
}

const SingleFacetLabel = memo(({templating, facet}: SingleFacetLabelProps) => {
    const ComponentName = useTemplatedComponent(templating, MANIFEST)

    return (
        <Suspense>
            <ComponentName facet={facet} />
        </Suspense>
    )
})
SingleFacetLabel.displayName = "SingleFacetLabel"

export default connect(SingleFacetLabel)
